<template>
  <div>
    <b-modal
      ref="searchTemplate"
      cancel-variant="outline-danger"
      @ok.prevent="saveSearch"
      :ok-disabled="isSubmitting"
      @hidden="$emit('hidden')"
      size="lg"
      hide-footer
      modal-class="template-modal"
    >
      <template #modal-header>
        <h5 class="font-bold">保存した検索条件</h5>
      </template>
      <div class="template-container">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>検索条件名</th>
                <th>ログイン時の初期表示条件</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in templates" :key="template.id">
                <td
                  @click="openSearchReflect(template)"
                  style="cursor: pointer; color: #036AC9"
                >
                  {{ template.title }}
                </td>
                <td>
                  <div class="form-check">
                    <input
                      class="form-check-input custom-checkbox"
                      type="checkbox"
                      :id="'is_default_' + template.id"
                      :checked="template.is_default"
                      @change="
                        ($event) =>
                          handleDefaultToggle(template, $event.target.checked)
                      "
                    />
                  </div>
                </td>
                <td class="d-flex justify-content-center">
                  <button
                    class="btn-plain btn-heart template-Btn"
                    @click="editTemplate(template)"
                  >
                    <img
                      :src="require('@/assets/images/pencil.svg')"
                      alt="編集"
                      class="icon-label"
                    />
                  </button>
                  <button
                    class="btn-plain btn-heart template-Btn ml-2"
                    @click="showDeleteConfirmation(template)"
                  >
                    <img
                      :src="require('@/assets/images/dustbin.svg')"
                      alt="削除"
                      class="icon-label"
                    />
                  </button>
                </td>
                <EditSearchTemplate
                  v-if="selectedTemplate && selectedTemplate.id === template.id"
                  :template="template"
                  :showModal="isModalEdit"
                  @hideSearchModal="hideSearchModal"
                />
              </tr>
              <tr v-if="!templates.length">
                <td colspan="100%" class="text-center">
                  テンプレートが見つかりません。
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <confirmation-modal
      ref="deleteConfirmation"
      message="この検索条件を削除しますか？"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
    />
  </div>
</template>

<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import ConfirmationModal from '@/components/utils/ConfirmationModal.vue';
import EditSearchTemplate from '../../../views/EditSearchTemplate.vue';
import { mapMutations } from 'vuex';
import mutations from '@/config/mutations';
export default {
  name: 'SearchTemplateModal',
  components: {
    ConfirmationModal,
    EditSearchTemplate,
  },
  props: {
    templates: {
      type: Array,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    fromHomePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateToDelete: null,
      isModalEdit: false,
      selectedTemplate: null,
      isSearchReflect: false,
    };
  },
  methods: {
    ...mapMutations(['mutateSearchTemplateAfterChange', 'unsetTemplate', mutations.applicant.CHANGE_SEARCH_PARAMS]),
    openSearchReflect(template) {
      console.log(template);
      if(template.search) {
        // Instead of using CHANGE_SEARCH_PARAMS, directly populate the form models
        this.$emit('prepopulateForm', template.search);
      }
      this.$refs.searchTemplate.hide();
    },
    show() {
      this.$refs.searchTemplate.show();
    },
    hide() {
      this.$refs.searchTemplate.hide();
      this.$emit('hidden');
    },
    showDeleteConfirmation(template) {
      this.templateToDelete = template;
      this.$refs.deleteConfirmation.show();
    },
    cancelDelete() {
      this.templateToDelete = null;
    },
    async confirmDelete(template) {
      if (this.templateToDelete) {
        try {
          await ApiService.delete(
            Api.endpoints.DELETE_TEMPLATE(this.templateToDelete.id)
          );
          this.unsetTemplate(this.templateToDelete);
        } catch (error) {
          console.error('Error deleting template:', error);
        }
        this.templateToDelete = null;
      }
    },
    async handleDefaultToggle(template, isChecked) {
      // Remember original state before changes
      const wasDefault = template.is_default;

      // Update UI immediately
      this.templates.forEach((t) => {
        if (isChecked && t.id !== template.id) {
          t.is_default = false;
        } else if (t.id === template.id) {
          t.is_default = isChecked;
        }
      });

      try {
        // Call API if we're changing the default status (either setting or unsetting)
        if (isChecked || wasDefault) {
          const { data } = await ApiService.get(
            Api.endpoints.TEMPLATE_STATUS_CHANGE(template.id)
          );
          this.mutateSearchTemplateAfterChange(data.data);
        }
      } catch (error) {
        console.error('Error updating default template:', error);
        // Restore previous state on error - assuming loadTemplates() exists
        // this.loadTemplates();

        // Or manually revert to previous state
        this.templates.forEach((t) => {
          if (t.id === template.id) {
            t.is_default = wasDefault;
          }
        });
      }
    },
    // async handleDefaultChange(template) {
    //   try {
    //     const { data } = await ApiService.get(
    //       Api.endpoints.TEMPLATE_STATUS_CHANGE(template.id)
    //     );
    //     this.mutateSearchTemplateAfterChange(data.data);
    //   } catch (error) {
    //     console.error('Error updating default template:', error);
    //   }
    // },
    hideSearchModal(isHideTemplate) {
      this.isModalEdit = false; // Hide the modal
      this.selectedTemplate = null; // Clear the selected template
      if (isHideTemplate) {
        this.hide();
      }
    },
    editTemplate(template) {
      this.isSearchReflect = false;
      this.selectedTemplate = template; // Set the selected template
      this.isModalEdit = true; // Show the modal
    },
  },
};
</script>

<style scoped>
.form-check-input.custom-checkbox {
  width: 16px;
  height: 16px;
}
.template-container {
  max-height: 500px;
  overflow-y: auto;
}
.template-modal .modal-body {
  padding: 0px !important;
}
.btn-plain.template-Btn {
  background-color: #ffffff;
  min-width: 30px;
  width: 30px;
}
table th {
  text-align: center;
}
table td {
  text-align: center;
}
</style>
